import { definedValue } from '../../../utils';
import { detectDevice } from '../../../tppServices/crossEnvHelpers';

const openFullScreen = (element) => {
  const doc = definedValue(element, document.documentElement);
  if (doc.requestFullscreen) {
    doc.requestFullscreen();
  } else if (doc.webkitRequestFullscreen) {
    doc.webkitRequestFullscreen();
  } else if (doc.msRequestFullscreen) {
    doc.msRequestFullscreen();
  }
};

const isFullScreen = (doc) => !!(doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement);

const exitFullScreen = (doc) => {
  const element = definedValue(doc, document);
  if (detectDevice() !== 'desktop') {
    return;
  }
  if (!isFullScreen(element)) {
    return;
  }
  if (element.exitFullscreen) {
    element.exitFullscreen();
  } else if (element.webkitExitFullscreen) {
    element.webkitExitFullscreen();
  } else if (element.msExitFullscreen) {
    element.msExitFullscreen();
  }
};

const viewFullScreen = (fullScreen) => {
  if (detectDevice() !== 'desktop') {
    return;
  }
  if (fullScreen) {
    openFullScreen();
  } else {
    exitFullScreen();
  }
};

export { viewFullScreen, isFullScreen, exitFullScreen, openFullScreen };
